module.exports = __webpack_public_path__ + "img/ic_salary.a1003f93.png";